(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5024],{

/***/ 13880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),

/***/ 69737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ badges_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-const.js
var badges_const = __webpack_require__(25627);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./components/core/images-gallery/images-gallery-row/images-gallery-row-component.js + 3 modules
var images_gallery_row_component = __webpack_require__(99112);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/default-props.js
var default_props = __webpack_require__(26455);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-desktop/badges-grid-desktop-component.scss.js



var StyledBadgesGridDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1duxf0w0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding-right:", function(param) {
    var horizontalPadding = param.horizontalPadding;
    return horizontalPadding || default_props/* default.horizontalPadding */.Z.horizontalPadding;
}, ";padding-left:", function(param) {
    var horizontalPadding = param.horizontalPadding;
    return horizontalPadding || default_props/* default.horizontalPadding */.Z.horizontalPadding;
}, ";.images-gallery-row{flex-wrap:nowrap;gap:12px;.image-gallery{.picture-component{img{min-width:72px;width:100%;height:100%;object-fit:contain;max-width:120px;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-desktop/badges-grid-desktop-component.js



var BadgesGridDesktopComponent = function(param) {
    var badges = param.badges, horizontalPadding = param.horizontalPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadgesGridDesktopComponent, {
        horizontalPadding: horizontalPadding,
        className: "badges-grid-desktop-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_gallery_row_component/* default */.Z, {
            assets: badges
        })
    });
};
/* harmony default export */ var badges_grid_desktop_component = (BadgesGridDesktopComponent);

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-mobile/badges-grid-mobile-component.scss.js

var StyledBadgesGridMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehaikjk0"
})(".badge-wrapper{padding:8px;}.slick-list{padding:0 20% 0;.slick-track{.slick-slide{.picture-component{img{width:100%;height:100%;object-fit:contain;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-mobile/badges-grid-mobile-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var BadgesGridMobileComponent = function(param) {
    var badges = param.badges;
    var itemRenderer = function(param) {
        var url = param.url, name = param.name;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "badge-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                src: url,
                alt: name
            })
        });
    };
    var carouselProps = {
        items: badges,
        itemRenderer: itemRenderer,
        defaultIndex: Math.floor(badges.length / 2),
        infinite: false,
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadgesGridMobileComponent, {
        className: "badges-grid-mobile-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, _object_spread({}, carouselProps))
    });
};
/* harmony default export */ var badges_grid_mobile_component = (BadgesGridMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-grid-component.js







var BadgesGridComponent = function(param) {
    var product = param.product, country = param.country, horizontalPadding = param.horizontalPadding;
    var badges = (0,react.useMemo)(function() {
        var _BADGES_PER_PRODUCT_BY_COUNTRY_product, _BADGES_PER_PRODUCT_BY_COUNTRY_product1;
        return ((_BADGES_PER_PRODUCT_BY_COUNTRY_product = badges_const/* BADGES_PER_PRODUCT_BY_COUNTRY */.M[product]) === null || _BADGES_PER_PRODUCT_BY_COUNTRY_product === void 0 ? void 0 : _BADGES_PER_PRODUCT_BY_COUNTRY_product[country]) || ((_BADGES_PER_PRODUCT_BY_COUNTRY_product1 = badges_const/* BADGES_PER_PRODUCT_BY_COUNTRY */.M[product]) === null || _BADGES_PER_PRODUCT_BY_COUNTRY_product1 === void 0 ? void 0 : _BADGES_PER_PRODUCT_BY_COUNTRY_product1[badges_const/* BADGES_COUNTRIES.GENERAL */.W.GENERAL]) || badges_const/* BADGES_PER_PRODUCT_BY_COUNTRY */.M[products/* WORK_MANAGEMENT_PRODUCT_ID */.py][badges_const/* BADGES_COUNTRIES.GENERAL */.W.GENERAL];
    }, [
        product
    ]);
    var BadgesResponsiveComponent = (0,react.useMemo)(function() {
        return (0,responsive_hoc_component/* default */.Z)(badges_grid_desktop_component, badges_grid_mobile_component);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgesResponsiveComponent, {
        badges: badges,
        horizontalPadding: horizontalPadding
    });
};
/* harmony default export */ var badges_grid_component = (BadgesGridComponent);


/***/ })

}]);